import { id } from '@monorepo/tools/src/lib/types/primitives';
import { CrudEndpoint } from './crud.endpoint';

export class LinksEndpoint extends CrudEndpoint {
	constructor() {
		super('publisher');
	}

	generateLink(): string {
		return `${this.baseUrl}/generate-link`;
	}

	myLinks(accountId: id): string {
		return `${this.baseUrl}/${accountId}/publisher-links`;
	}

	stopLink(linkId: id): string {
		return `${this.baseUrl}/link/${linkId}/stop`;
	}

	regenerateLink(linkId: id): string {
		return `${this.baseUrl}/link/${linkId}/regenerate`;
	}
}
